export const swiperLoader = {
    swiperLoaded:false,
    scriptPath: '',
    init(scriptPath?: string) {
        this.scriptPath = scriptPath || '';
        // Load swiper dynamically
        const $swipers: NodeListOf<HTMLElement> | null = document.querySelectorAll('[data-ot-swiper]');

        const observerOptions = {
            rootMargin: '0% 0px 0% 0px',
        };

        if (!this.swiperLoaded) {
            $swipers?.forEach(($swiper) => {
                const loadMethod: string | null = $swiper.getAttribute('data-ot-swiper-load');

                if (loadMethod === 'scroll') {
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (this.swiperLoaded) {
                                observer.disconnect();
                            } else {
                                if (entry.isIntersecting) {
                                    this.loadSwiper(() => {
                                        observer.disconnect();
                                    });
                                }
                            }
                        });
                    }, observerOptions);

                    observer.observe($swiper);
                }

                if (loadMethod === 'delay') {
                    setTimeout(() => {
                        if (!this.swiperLoaded) {
                            console.log('load delay');
                            this.loadSwiper()
                        }
                    }, 1000);
                }
            });
        }
    },
    loadSwiper(cb?: () => void) {
        const script = document.createElement('script');
        script.type = "text/javascript";

        // script.src = 'https://assets.ot.digital/saas/dist/js/core-content-swiper.js';
        script.src = this.scriptPath + 'saas-swiper.min.js';
        document.head.appendChild(script);

        script.onload = () => {
            this.swiperLoaded = true;
            cb && cb();
        }
    }
}